import { useState, useEffect, useRef, useContext } from "react";
import { classNames } from "primereact/utils";
import { Route, Routes, useLocation } from "react-router-dom";
import AppTopbar from "./layouts/AppTopbar";
import AppMenu from "./layouts/AppMenu";
import { Tooltip } from "primereact/tooltip";

import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./App.scss";

import Profile from "./pages/Profile/Profile";
import Dashboard from "./pages/dashboard/Dashboard";
import ManageUsers from "./pages/users/ManageUsers";
import EmployeesList from "./pages/employees/EmployeesList";
import ChangePassword from "./pages/Profile/ChangePassword";
import UserTaxFileList from "./pages/TaxList/UserTaxFileList";

import GlobalSetting from "./pages/globalSetting/GlobalSetting";
import { TaxPayerTab } from "./pages/TaxList/TaxPayerTab";
import PaymentSuccess from "./pages/PaymentSuccess/PaymentSuccess";
import AddTaxPayerManually from "./pages/TaxList/addTaxPayerManually";
import PendingFileList from "./pages/TaxList/PendingFileList";
import TaxpayerStatus from "./pages/TaxList/taxpayerStatus";
import CompanyList from "./pages/TaxList/CompanyList";
import CompanyFilingTab from "./pages/TaxList/CompanyFilingTab";
import UberCalcList from "./pages/uberCalc/UberCalcList";
import AddEditUberCalc from "./pages/uberCalc/AddEditUberCalc";
import UberCalcDetail from "./pages/uberCalc/UberCalcDetail";

const App = () => {
  const [menuMode, setMenuMode] = useState("slim");
  const [overlayMenuActive, setOverlayMenuActive] = useState(false);
  const [sidebarStatic, setSidebarStatic] = useState(false);
  const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
  const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [topbarMenuActive, setTopbarMenuActive] = useState(false);
  const [sidebarActive, setSidebarActive] = useState(false);
  const [pinActive, setPinActive] = useState(false);
  const [activeInlineProfile, setActiveInlineProfile] = useState(false);
  const [resetActiveIndex, setResetActiveIndex] = useState<boolean>(false);
  const [assignedActions, setAssignedActions] = useState<any>([]);
  const copyTooltipRef = useRef<any>();
  const location = useLocation();
  const rawUserData = localStorage.getItem("user_data");

  let userData: any = null;

  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const updateTime = 60000;
  let menuClick: any;
  let topbarItemClick: any;

  // use effect method
  useEffect(() => {
    getUserDetails();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setMenuMode("sidebar");
      } else {
        setMenuMode("slim");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //userDetail
  const getUserDetails = async () => {
    const response = localStorage.getItem('menu_access');
    if (response) {
      let tempAssignedActions = response.split(',');
      tempAssignedActions.push('Dashboard');
      setAssignedActions(tempAssignedActions);
      assignedMenu(tempAssignedActions);
    }
  };

  // Make roles menu
  const assignedMenu = (assignedActions: any) => {
    let newMenu: any = menu;
    if (!window.cn(assignedActions)) {
      //check for assigned roles
      for (let i = 0; i < assignedActions.length; i++) {
        for (let j = 0; j < newMenu.length; j++) {
          //check if inner roles exists
          if (newMenu[j].hasOwnProperty('items')) {
            let items: any = newMenu[j].items;
            //check for inner roles
            for (let k = 0; k < items.length; k++) {
              //if role is assigned change status to 1
              if (items[k].label == assignedActions[i]) {
                items[k].status = '1';
              }
            }
          } else {
            //if role is assigned change status to 1
            if (newMenu[j].label == assignedActions[i]) {
              newMenu[j]['status'] = '1';
            }
          }
        }
      }

      //Create new array for assisgned roles to display in sidebar
      let newAssignedRoles = [];
      for (let j = 0; j < newMenu.length; j++) {
        if (newMenu[j].hasOwnProperty('items')) {
          //check for inner roles
          let items: any = newMenu[j].items;
          for (let k = 0; k < items.length; k++) {
            if (items[k]['status'] != undefined) {
              //check if value exists in array of object or not
              let valueExists = newAssignedRoles.some((el: any) => el.label == newMenu[j]['label']);
              //if value exists in array of object the push in items array
              if (valueExists) {
                for (let x = 0; x < newAssignedRoles.length; x++) {
                  if (newAssignedRoles[x]['label'] == newMenu[j]['label']) {
                    newAssignedRoles[x]['items']?.push(items[k]);
                  }
                }
              } else {
                //if value does not exusts in array object then push new object in array
                newAssignedRoles.push({
                  label: newMenu[j]['label'],
                  icon: newMenu[j]['icon'],
                  items: [items[k]]
                });
              }
            }
          }
        } else {
          if (newMenu[j]['status'] != undefined) {
            newAssignedRoles.push(newMenu[j]);
          }
        }
      }
      setAssignedActions(newAssignedRoles);
    }
  };


  let menu = [
    { to: "/dashboard", icon: "pi pi-home", label: "Dashboard" },
    {
      to: "/employees",
      icon: "pi pi-users",
      label: "Manage Employees",
    },
    { to: "tax-payer-list", icon: "pi pi-file", label: "Tax Payer List" },
    { to: "company-list", icon: "pi pi-building", label: "Company List" },
    { to: "gst-calc", icon: "pi pi-calculator", label: "GST Calc" },
  ];

  // const getMenuItems = () => {
  //   if (!userData?.role) return [];
  //   switch (userData?.role) {
  //     case "Admin":
  //       return [
  //         { to: "/dashboard", icon: "pi pi-home", label: "Dashboard" },
  //         {
  //           to: "/employees",
  //           icon: "pi pi-users",
  //           label: "Manage Employees",
  //         },
  //         { to: "tax-payer-list", icon: "pi pi-file", label: "Tax Payer List" },
  //         { to: "company-list", icon: "pi pi-building", label: "Company List" },
  //       ];
  //     case "User":
  //       return [{ to: "/dashboard", icon: "pi pi-home", label: "Dashboard" }];
  //     case "Employee":
  //       return [
  //         { to: "/dashboard", icon: "pi pi-home", label: "Dashboard" },
  //         { to: "tax-payer-list", icon: "pi pi-slack", label: "Tax List" },
  //       ];
  //     default:
  //       return [];
  //   }
  // };

  useEffect(() => {
    copyTooltipRef.current?.updateTargetEvents();
  }, [location]);

  useEffect(() => {
    setResetActiveIndex(true);
    setMenuActive(false);
  }, [menuMode]);

  const onDocumentClick = () => {
    if (!topbarItemClick) setTopbarMenuActive(false);

    if (!menuClick) {
      if (isHorizontal() || isSlim()) {
        setMenuActive(false);
        setResetActiveIndex(true);
      }

      if (overlayMenuActive || staticMenuMobileActive) {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
        unblockBodyScroll();
      }
    }

    topbarItemClick = false;
    menuClick = false;
  };

  const onMenuButtonClick = (event: any) => {
    menuClick = true;

    if (isOverlay()) {
      setOverlayMenuActive((prev) => {
        const newState = !prev;
        newState ? blockBodyScroll() : unblockBodyScroll();
        return newState;
      });
    }

    if (isDesktop()) {
      setStaticMenuDesktopInactive((prev) => !prev);
    } else {
      setStaticMenuMobileActive((prev) => {
        const newState = !prev;
        newState ? blockBodyScroll() : unblockBodyScroll();
        return newState;
      });
    }

    event.preventDefault();
  };

  const blockBodyScroll = () => {
    document.body.classList.add("blocked-scroll");
  };

  const unblockBodyScroll = () => {
    if (document.body.classList) {
      document.body.classList.remove("blocked-scroll");
    } else {
      document.body.className = document.body.className.replace(new RegExp("(^|\\b)" + "blocked-scroll".split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
  };

  const onTopbarItemClick = (event: any) => {
    topbarItemClick = true;
    setTopbarMenuActive((prev) => !prev);
    hideOverlayMenu();
    event.preventDefault();
  };

  const onToggleMenu = (event: any) => {
    menuClick = true;
    if (overlayMenuActive) setOverlayMenuActive(false);
    if (sidebarActive) setSidebarStatic((prev) => !prev);
    event.preventDefault();
  };

  const hideOverlayMenu = () => {
    setOverlayMenuActive(false);
    setStaticMenuMobileActive(false);
    unblockBodyScroll();
  };

  const onSidebarMouseOver = () => {
    if (menuMode === "sidebar" && !sidebarStatic) {
      setSidebarActive(isDesktop());
      setTimeout(() => setPinActive(isDesktop()), 200);
    }
  };

  const onSidebarMouseLeave = () => {
    if (menuMode === "sidebar" && !sidebarStatic) {
      setTimeout(() => {
        setSidebarActive(false);
        setPinActive(false);
      }, 250);
    }
  };

  const onMenuClick = () => {
    menuClick = true;
  };

  const onChangeActiveInlineMenu = (e: any) => {
    setActiveInlineProfile((prev) => !prev);
    e.preventDefault();
  };

  const onRootMenuItemClick = () => {
    setMenuActive((prev) => !prev);
  };

  const onMenuItemClick = (event: any) => {
    if (!event.item.items) {
      hideOverlayMenu();
      setResetActiveIndex(true);
    }

    if (!event.item.items && (isHorizontal() || isSlim())) {
      setMenuActive(false);
    }
  };

  const isHorizontal = () => menuMode === "horizontal";
  const isSlim = () => menuMode === "slim";
  const isOverlay = () => menuMode === "overlay";
  const isDesktop = () => window.innerWidth > 991;

  const layoutClassName = classNames("layout-wrapper", {
    "layout-static": menuMode === "static",
    "layout-overlay": menuMode === "overlay",
    "layout-overlay-active": overlayMenuActive,
    "layout-slim": menuMode === "slim",
    "layout-horizontal": menuMode === "horizontal",
    "layout-active": menuActive,
    "layout-mobile-active": staticMenuMobileActive,
    "layout-sidebar": menuMode === "sidebar",
    "layout-sidebar-static": menuMode === "sidebar" && sidebarStatic,
    "layout-static-inactive": staticMenuDesktopInactive && menuMode === "static",
  });

  return (
    <div className={layoutClassName} onClick={onDocumentClick}>
      <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

      <AppTopbar
        items={assignedActions}
        updateTime={updateTime}
        menuMode={menuMode}
        topbarMenuActive={topbarMenuActive}
        activeInlineProfile={activeInlineProfile}
        onTopbarItemClick={onTopbarItemClick}
        onMenuButtonClick={onMenuButtonClick}
        onToggleMenu={onToggleMenu}
      />

      <AppMenu
        model={assignedActions}
        onRootMenuItemClick={onRootMenuItemClick}
        onMenuItemClick={onMenuItemClick}
        onToggleMenu={onToggleMenu}
        onMenuClick={onMenuClick}
        menuMode={menuMode}
        menuActive={menuActive}
        sidebarActive={sidebarActive}
        sidebarStatic={sidebarStatic}
        pinActive={pinActive}
        onSidebarMouseLeave={onSidebarMouseLeave}
        onSidebarMouseOver={onSidebarMouseOver}
        activeInlineProfile={activeInlineProfile}
        onChangeActiveInlineMenu={onChangeActiveInlineMenu}
        resetActiveIndex={resetActiveIndex}
      />

      <div className="layout-main">
        <div className="layout-main-content">
          <Routes>
            {/* profile route start */}
            <Route path="/profile" element={<Profile />} />
            {/* profile route end */}

            {/* gloval setting */}
            <Route path="/global-setting" element={<GlobalSetting />} />
            {/* dashboard route start */}
            <Route path="/dashboard" element={<Dashboard />} />
            {/* dashboard route end */}
            {/* user route start */}
            <Route path="/users" element={<ManageUsers />} />
            {/* user route end */}
            {/* employee route start */}
            <Route path="/employees" element={<EmployeesList />} />
            {/* employee route end */}
            {/* change password route start */}
            <Route path="/change-password" element={<ChangePassword />} />
            {/* change password route end */}

            {/* tax list route start */}
            <Route path="tax-payer-list" element={<UserTaxFileList />} />
            <Route path="company-list" element={<CompanyList />} />
            <Route path="pending-file-list" element={<PendingFileList />} />
            <Route path="taxpayer-status" element={<TaxpayerStatus />} />
            <Route path="taxlist/add-tax-payer-manually" element={<AddTaxPayerManually />} />
            {/* <Route path="tax-payer/detail/:id" element={<UserTaxDetail />} /> */}
            {/* tax list route start */}

            {/* tax payer detail tab */}
            <Route path="tax-payer-detail/:id" element={<TaxPayerTab />} />
            <Route path="company-detail/:id" element={<CompanyFilingTab />} />

            {/* payment success */}
            <Route path="/payment-sucess/:taxFormId" element={<PaymentSuccess />} />

            {/* uber calc */}
            <Route path="gst-calc" element={<UberCalcList />} />
            <Route path="gst-calc/add" element={<AddEditUberCalc />} />
            <Route path="gst-calc/edit/:id" element={<AddEditUberCalc />} />
            <Route path="gst-calc/view/:id" element={<UberCalcDetail />} />

            <Route path="*" element={<Dashboard />} />
          </Routes>
        </div>
        {/* show mask when mobile active sidebar */}
        {(staticMenuMobileActive || overlayMenuActive) && <div className="layout-mask" />}
      </div>
    </div>
  );
};

export default App;
